import React from 'react'

import { DirectBankLinkingRedirect } from '@acorns/web-bank-linking'

const FALLBACK_URL = `${window.location.origin}/settings/linked-accounts/link`

export const LinkInstitutionRedirect = () => {
  return <DirectBankLinkingRedirect fallbackUrl={FALLBACK_URL} />
}
